import * as types from './_actionTypes';

const initialState = {
  studentAnalytics: {},
  contentPerformance: [],
  loading: false,
  exporting: false,
  error: null
};

const smeStudentAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STUDENT_ANALYTICS_REQUEST:
    case types.FETCH_CONTENT_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_STUDENT_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        studentAnalytics: action.payload,
        error: null
      };
    
    case types.FETCH_CONTENT_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        contentPerformance: action.payload,
        error: null
      };
    
    case types.FETCH_STUDENT_ANALYTICS_FAILURE:
    case types.FETCH_CONTENT_PERFORMANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.EXPORT_ANALYTICS_REPORT_REQUEST:
      return {
        ...state,
        exporting: true,
        error: null
      };
    
    case types.EXPORT_ANALYTICS_REPORT_SUCCESS:
      return {
        ...state,
        exporting: false,
        error: null
      };
    
    case types.EXPORT_ANALYTICS_REPORT_FAILURE:
      return {
        ...state,
        exporting: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default smeStudentAnalyticsReducer;